import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { topRatedHelpers } from 'site-modules/shared/utils/top-rated/top-rated-helpers';
import { WinnerCard } from 'site-modules/editorial/components/top-rated/winner-tiles-nav/2026/winner-card';
import { RevealOnIntersect } from 'site-modules/editorial/components/top-rated/reveal-on-intersect/reveal-on-intersect';
import { ElectricBolt } from 'site-modules/editorial/components/top-rated/icons/electric-bolt';
import { BestOfTheBest } from './best-of-the-best';

export function WinnerTilesNav({ entry, pagePaths = null, isMobile = false, year = null }) {
  const rawWinnersEntries = entry.children();
  const winnersEntries = topRatedHelpers.mapWinners2023(rawWinnersEntries, pagePaths);
  const winnerTitle = entry.metadata('winnerTitle').value();
  const botbTileEntry = winnersEntries[0];
  const iceWinners = winnersEntries.filter((winnerEntry, index) => {
    return index !== 0 && !winnerEntry.metadata('categoryTitle').value().toLowerCase().includes('electric');
  });
  const evWinners = winnersEntries.filter((winnerEntry, index) => {
    return index !== 0 && winnerEntry.metadata('categoryTitle').value().toLowerCase().includes('electric');
  });
  const getWinnerTitle = isElectric => {
    const split = winnerTitle.split(' ');
    const firstLine = split[0];
    const lastWord = split[split.length - 1];
    let restOfCopy = winnerTitle.replace(firstLine, '').trim();
    if (isElectric) {
      const electricFirst = restOfCopy.replace(lastWord, '').trim();
      const electricRest = (
        <Fragment>
          <span className="electric-text fst-italic">
            <ElectricBolt size={40} wrapperClass="pos-r d-inline-block mx-0_25 show-fill hidden-md-down" />
            <ElectricBolt size={24} wrapperClass="pos-r d-inline-block mx-0_25 show-fill hidden-md-up" />
            {`Electric `}
          </span>
          {lastWord}
        </Fragment>
      );
      restOfCopy = (
        <Fragment>
          {electricFirst}
          {electricRest}
        </Fragment>
      );
    }
    return (
      <div className="text-white text-center fw-bold pb-2_5 pt-1">
        <div className="text-orange-60 fw-medium pb-0_5">
          <span className="size-24 hidden-md-down">{firstLine}</span>
          <span className="size-20 hidden-md-up">{firstLine}</span>
        </div>
        <span className="hidden-md-down" style={{ fontSize: '48px' }}>
          {restOfCopy}
        </span>
        <span className="size-30 hidden-md-up">{restOfCopy}</span>
      </div>
    );
  };

  const wrapperClass = 'd-md-flex justify-content-between winner-runner-ups mx-auto';

  return (
    <article
      className={`winner-tile-container mx-auto tile-${winnersEntries.length}`}
      key={entry.id}
      style={{ maxWidth: '1200px' }}
    >
      {botbTileEntry && (
        <RevealOnIntersect>
          <BestOfTheBest tileEntry={botbTileEntry} index={0} isMobile={isMobile} year={year} />
        </RevealOnIntersect>
      )}
      <RevealOnIntersect>
        {getWinnerTitle(false)}
        <article
          className={wrapperClass}
          style={{
            columnGap: '2rem',
            paddingBottom: '80px',
            maxWidth: '1040px',
          }}
        >
          {iceWinners.map(
            (tileEntry, index) =>
              tileEntry && (
                <WinnerCard
                  tileEntry={tileEntry}
                  index={index + 1}
                  key={`${tileEntry.metadata('categoryTitle').value()}-${tileEntry.metadata('vehicleTitle').value()}`}
                  isMobile={isMobile}
                  style={{ flex: '1 1 33.33%' }}
                />
              )
          )}
        </article>

        {getWinnerTitle(true)}
        <article
          className={wrapperClass}
          style={{
            columnGap: '2rem',
            maxWidth: '1040px',
          }}
        >
          {evWinners.map(
            (tileEntry, index) =>
              tileEntry && (
                <WinnerCard
                  tileEntry={tileEntry}
                  index={index + iceWinners.length + 1}
                  key={`${tileEntry.metadata('categoryTitle').value()}-${tileEntry.metadata('vehicleTitle').value()}`}
                  isMobile={isMobile}
                  style={{ flex: '1 1 33.33%' }}
                  isElectric
                />
              )
          )}
        </article>
      </RevealOnIntersect>
    </article>
  );
}

WinnerTilesNav.propTypes = {
  entry: CmsEntities.Content.isRequired,
  isMobile: PropTypes.bool,
  pagePaths: PropTypes.arrayOf(PropTypes.string),
  year: PropTypes.string,
};
